import { Search, X } from "lucide-react";

const words = (s) => s.toLowerCase().split(/\s+/).filter(Boolean);

export const filterProducts = (data, { q, cat, brand }) => {
  const terms = words(q);
  return data.filter((p) => {
    if (cat && p.category !== cat) return false;
    if (brand && p.brand !== brand) return false;
    const hay = `${p.name} ${p.brand} ${p.category} ${p.size} ${p.description}`.toLowerCase();
    return terms.every((t) => hay.includes(t));
  });
};

const options = (data, key) => {
  const counts = {};
  data.forEach((p) => { if (p[key]) counts[p[key]] = (counts[p[key]] || 0) + 1; });
  return Object.keys(counts).sort((a, b) => a.localeCompare(b)).map((k) => [k, counts[k]]);
};

export const ShopToolbar = ({ data, f, setF, shown }) => {
  const cats = options(data, "category");
  const brands = options(data, "brand");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const active = f.q || f.cat || f.brand;
  return (
    <div className="shop-toolbar" data-testid="shop-toolbar">
      <div className="wrap shop-toolbar-inner">
        <label className="shop-q">
          <Search size={16} aria-hidden="true" />
          <input type="search" value={f.q} onChange={set("q")} placeholder="Search products, e.g. lip gloss, serum, wax" aria-label="Search products" data-testid="shop-search-input" />
          {f.q && <button type="button" onClick={() => setF({ ...f, q: "" })} aria-label="Clear search" data-testid="shop-search-clear"><X size={15} /></button>}
        </label>
        {cats.length > 0 && (
          <select value={f.cat} onChange={set("cat")} aria-label="Category" data-testid="shop-category-select">
            <option value="">All categories</option>
            {cats.map(([k, n]) => <option key={k} value={k}>{k} ({n})</option>)}
          </select>
        )}
        {brands.length > 0 && (
          <select value={f.brand} onChange={set("brand")} aria-label="Brand" data-testid="shop-brand-select">
            <option value="">All brands</option>
            {brands.map(([k, n]) => <option key={k} value={k}>{k} ({n})</option>)}
          </select>
        )}
      </div>
      <div className="wrap shop-toolbar-meta">
        <span data-testid="shop-result-count">{shown} of {data.length} products</span>
        {active && <button type="button" onClick={() => setF({ q: "", cat: "", brand: "" })} data-testid="shop-clear-filters">Clear all</button>}
      </div>
    </div>
  );
};
